const navbarHeight = 80;

export { navbarHeight };
